'use strict';

// @codekit-prepend "/vendor/hammer-2.0.8.js";

$(() => {
  if (window.PortfolioFunctionsInitialized) return;
  window.PortfolioFunctionsInitialized = true;

  // State management
  let canScroll = true;
  let scrollController = null;
  const SCROLL_DEBOUNCE = 800;

  // Cache DOM elements
  const $sideNav = $('.side-nav');
  const $outerNav = $('.outer-nav');
  const $mainContent = $('.main-content');
  const $headerCta = $('.header--cta');
  const $perspective = $('.perspective');


  // Mouse wheel scroll handling
  $(document).on('mousewheel DOMMouseScroll', (e) => {
    // Prevent scrolling when interacting with form elements
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

    // Check if the event is cancelable to avoid warnings in some browsers
    if (e.cancelable) e.preventDefault();

    if ($outerNav.hasClass('is-vis')) return;

    e.preventDefault();
    const delta = e.originalEvent.wheelDelta
      ? -e.originalEvent.wheelDelta
      : e.originalEvent.detail * 20;

    if (Math.abs(delta) > 50 && canScroll) {
      canScroll = false;
      clearTimeout(scrollController);
      scrollController = setTimeout(() => { canScroll = true; }, SCROLL_DEBOUNCE);
      updateHelper(delta > 0 ? 1 : -1);
    }
  });

  // Navigation click & keyboard handling
  $('.side-nav li, .outer-nav li').on('click keypress', function (e) {
    if (e.type === 'keypress' && e.which !== 13) return; // Only Enter key

    const $this = $(this);
    if ($this.hasClass('is-active')) return;

    const $parent = $this.parent();
    const curPos = $parent.children().index($parent.find('.is-active'));
    const nextPos = $parent.children().index($this);
    const lastItem = $parent.children().length - 1;

    updateNavs(nextPos);
    updateContent(curPos, nextPos, lastItem);
  });

  // CTA button - scroll directly to last section
  $('.cta').on('click keypress', (e) => {
    if (e.type === 'keypress' && e.which !== 13) return;

    const curPos = $sideNav.children().index($sideNav.find('.is-active'));
    const lastItem = $sideNav.children().length - 1;

    if (curPos === lastItem) return;

    updateNavs(lastItem);
    updateContent(curPos, lastItem, lastItem);
  });

  // Touch swipe support (Hammer.js)
  if (typeof Hammer !== 'undefined') {
    const mc = new Hammer(document.body, { touchAction: 'pan-x' });
    mc.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
    mc.on('swipeup swipedown', (e) => {
      const curPos = $sideNav.children().index($sideNav.find('.is-active'));
      // Allow browser pull-to-refresh on Home when swiping down
      if (e.type === 'swipedown' && curPos === 0) return;

      // Prevent default and navigate for all other swipes
      if (e.cancelable) e.preventDefault();
      updateHelper(e);
    });
  }

  // Keyboard navigation (Arrow keys)
  $(document).on('keyup', (e) => {
    if ($outerNav.hasClass('is-vis')) return;
    if (e.keyCode === 38 || e.keyCode === 40) { // Up or Down arrow
      e.preventDefault();
      updateHelper(e);
    }
  });

  // Determine scroll direction and update
  function updateHelper(param) {
    const $active = $sideNav.find('.is-active');
    const curPos = $sideNav.children().index($active);
    const lastItem = $sideNav.children().length - 1;
    let nextPos;

    const isDown = param.type === 'swipeup' || param.keyCode === 40 || param > 0;
    const isUp = param.type === 'swipedown' || param.keyCode === 38 || param < 0;

    if (isDown) {
      nextPos = curPos === lastItem ? 0 : curPos + 1;
    } else if (isUp) {
      nextPos = curPos === 0 ? lastItem : curPos - 1;
    } else {
      return; // Invalid input
    }

    updateNavs(nextPos);
    updateContent(curPos, nextPos, lastItem);
  }

  // Sync side and outer navigations
  function updateNavs(nextPos) {
    $sideNav.children().removeClass('is-active').eq(nextPos).addClass('is-active');
    $outerNav.children().removeClass('is-active').eq(nextPos).addClass('is-active');
  }

  // Update main content area
  function updateContent(curPos, nextPos, lastItem) {
    const $sections = $mainContent.children();

    $sections.removeClass('section--is-active').eq(nextPos).addClass('section--is-active');
    $sections.children().removeClass('section--next section--prev');

    // Apply transition direction
    const isWrap = (curPos === lastItem && nextPos === 0) || (curPos === 0 && nextPos === lastItem);
    if (!isWrap) {
      const dir = curPos < nextPos ? 'section--next' : 'section--prev';
      $sections.eq(curPos).children().addClass(dir);
    }

    // Toggle header CTA visibility
    $headerCta.toggleClass('is-active', nextPos !== 0 && nextPos !== lastItem);
  }

  // Outer navigation modal
  function initOuterNav() {
    const $body = $('body');

    // Apply holographic effect to outer-nav text
    $outerNav.children('li').each(function () {
      const $li = $(this);
      if ($li.find('.holo-text').length) return; // Already initialized
      const text = $li.text().trim();
      $li.html(`
        <div class="holo-glow"><span>${text}</span></div>
        <span class="holo-text" data-text="${text}">${text}</span>
      `);
    });

    $('.header--nav-toggle').on('click keypress', function (e) {
      if (e.type === 'keypress' && e.which !== 13) return;

      $(this).addClass('is-active');
      $body.addClass('has-modalview');
      $perspective.addClass('perspective--modalview modalview');
      setTimeout(() => $perspective.addClass('effect-rotate-left--animate'), 25);
      $outerNav.add('.outer-nav li, .outer-nav--return').addClass('is-vis');
      if (window.CircuitBG) window.CircuitBG.start();

      // Move focus to first menu item for a11y
      setTimeout(() => $outerNav.find('.is-active').focus(), 400);
    });

    $('.outer-nav--return, .outer-nav li').on('click keypress', function (e) {
      if (e.type === 'keypress' && e.which !== 13) return;

      $('.header--nav-toggle').removeClass('is-active');
      $body.removeClass('has-modalview');
      $perspective.removeClass('effect-rotate-left--animate');
      setTimeout(() => {
        $perspective.removeClass('perspective--modalview modalview');
        if (window.CircuitBG) window.CircuitBG.stop();
        // Return focus to toggle
        $('.header--nav-toggle').focus();
      }, 400);
      $outerNav.add('.outer-nav li, .outer-nav--return').removeClass('is-vis');
    });

    $('.header--logo').on('click keypress', function (e) {
      if (e.type === 'keypress' && e.which !== 13) return;

      const $active = $sideNav.find('.is-active');
      const curPos = $sideNav.children().index($active);
      const lastItem = $sideNav.children().length - 1;

      if (curPos !== 0) {
        updateNavs(0);
        updateContent(curPos, 0, lastItem);
      }
    });
  }

  // Initialize
  initOuterNav();

  // Cyber Flip Card Handling (Home)
  $('.cg-card').on('click', function () {
    $(this).toggleClass('flipped');
  });

  // ══ ABOUT SECTION LOGIC ══
  // (Logic moved to assets/js/src/about-details.js for modularity)
});
